export default __webpack_public_path__ + "static/media/chain-5.4bdc66b8.png";